(() => {
  const SELECTOR = '[data-ele-sale-end]';
  const WISHLIST_BUTTON_SELECTOR = '.wishlist-hero-list-card-footer-add-to-cart';
  const wishlistProductCache = new Map();

  /*
   * YYYY/MM/DD HH:mm
   * ↓
   * 日本時間としてTimestampへ変換
   */
  function parseJstDate(value) {
    if (!value) return null;

    const match = value.trim().match(
      /^(\d{4})\/(\d{1,2})\/(\d{1,2})\s+(\d{1,2})(?::(\d{1,2}))?$/
    );

    if (!match) return null;

    const year = match[1];
    const month = String(match[2]).padStart(2, '0');
    const day = String(match[3]).padStart(2, '0');
    const hour = String(match[4]).padStart(2, '0');
    const minute = String(match[5] || '00').padStart(2, '0');

    const timestamp = Date.parse(
      `${year}-${month}-${day}T${hour}:${minute}:00+09:00`
    );

    return Number.isNaN(timestamp) ? null : timestamp;
  }


  function isSaleEnded(element) {
    const endValue = element.getAttribute('data-ele-sale-end');

    if (!endValue) return false;

    const endTime = parseJstDate(endValue);

    if (!endTime) return false;

    return Date.now() >= endTime;
  }


  function changeButtonText(button, text) {
    const textElement = button.querySelector('.button__text');

    if (textElement) {
      if (textElement.textContent !== text) {
        textElement.textContent = text;
      }

      return;
    }

    const visibleSpan = Array.from(
      button.querySelectorAll('span')
    ).find((span) => !span.classList.contains('sr-only'));

    if (visibleSpan) {
      if (visibleSpan.textContent !== text) {
        visibleSpan.textContent = text;
      }

      return;
    }

    if (button.textContent !== text) {
      button.textContent = text;
    }
  }


  /*
   * 商品詳細 / Quick Buy / Sticky
   */
  function disableBuyButtons(scope) {
    const submitButtons = scope.querySelectorAll(
      'button[type="submit"]'
    );

    submitButtons.forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');

      changeButtonText(button, '販売終了');
    });

    /*
     * Dynamic Checkout
     */
    scope.querySelectorAll('.shopify-payment-button').forEach((button) => {
      button.style.display = 'none';
    });
  }


  /*
   * 商品カード
   */
  function disableProductCard(card) {
    /*
     * Quick Buyの＋ボタンを停止
     */
    card.querySelectorAll('.product-card__quick-add-button').forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');

      if (button.style.display !== 'none') {
        button.style.display = 'none';
      }
    });

    /*
     * 「販売終了」を表示
     */
    const status = card.querySelector('[data-ele-sale-status]');

    if (status) {
      status.hidden = false;

      const statusButton = status.querySelector('button');

      if (statusButton) {
        changeButtonText(statusButton, '販売終了');
      }
    }
  }

  /*
    * Wishlist商品Handle取得
    */
    function getWishlistProductHandle(card) {
    const productLink = card.querySelector(
        '.wishlist-hero-list-card-header-product-name[href*="/products/"]'
    );

    if (!productLink) return null;

    try {
        const url = new URL(
        productLink.getAttribute('href'),
        window.location.origin
        );

        const match = url.pathname.match(/\/products\/([^/?#]+)/);

        return match ? decodeURIComponent(match[1]) : null;
    } catch (error) {
        return null;
    }
    }


    /*
    * 商品情報取得
    */
    function fetchWishlistProduct(handle) {
    if (wishlistProductCache.has(handle)) {
        return wishlistProductCache.get(handle);
    }

    const root =
        window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    const request = fetch(
        `${root}products/${encodeURIComponent(handle)}.js`
    )
        .then((response) => {
        if (!response.ok) {
            throw new Error('Product fetch failed');
        }

        return response.json();
        })
        .catch((error) => {
        wishlistProductCache.delete(handle);
        throw error;
        });

    wishlistProductCache.set(handle, request);

    return request;
    }


    /*
    * START / ENDタグ取得
    */
    function getWishlistSalePeriod(tags) {
    if (!Array.isArray(tags)) {
        return {
        start: null,
        end: null
        };
    }

    let start = null;
    let end = null;

    tags.forEach((tag) => {
        if (typeof tag !== 'string') return;

        if (tag.startsWith('START_')) {
        start = tag.replace('START_', '').trim();
        }

        if (tag.startsWith('END_')) {
        end = tag.replace('END_', '').trim();
        }
    });

    return {
        start,
        end
    };
    }


    /*
    * 販売開始表示用
    */
    function formatWishlistStartDate(value) {
    if (!value) return '';

    const match = value.trim().match(
        /^(\d{4})\/(\d{1,2})\/(\d{1,2})\s+(\d{1,2})(?::(\d{1,2}))?$/
    );

    if (!match) return '';

    const month = String(match[2]).padStart(2, '0');
    const day = String(match[3]).padStart(2, '0');
    const hour = String(match[4]).padStart(2, '0');
    const minute = String(match[5] || '00').padStart(2, '0');

    return `${month}/${day} ${hour}:${minute}`;
    }


    /*
    * Wishlistボタンの元状態を保存
    */
    function saveWishlistButtonState(button) {
    if (button.dataset.eleOriginalLabel !== undefined) {
        return;
    }

    const label = button.querySelector('.MuiButton-label');

    button.dataset.eleOriginalLabel = label
        ? label.textContent.trim()
        : 'ADD TO CART';

    button.dataset.eleOriginalDisabled =
        button.disabled ? 'true' : 'false';
    }


    /*
    * Wishlist購入ボタンを無効化
    */
    function disableWishlistButton(button, text) {
    saveWishlistButtonState(button);

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.dataset.eleWishlistBlocked = 'true';

    const label = button.querySelector('.MuiButton-label');

    if (label && label.textContent !== text) {
        label.textContent = text;
    }
    }


    /*
    * Wishlist購入ボタンを通常状態へ戻す
    */
    function restoreWishlistButton(button) {
    saveWishlistButtonState(button);

    const originallyDisabled =
        button.dataset.eleOriginalDisabled === 'true';

    button.disabled = originallyDisabled;

    if (originallyDisabled) {
        button.setAttribute('aria-disabled', 'true');
    } else {
        button.removeAttribute('aria-disabled');
    }

    delete button.dataset.eleWishlistBlocked;

    const label = button.querySelector('.MuiButton-label');
    const originalLabel = button.dataset.eleOriginalLabel;

    if (
        label &&
        originalLabel &&
        label.textContent !== originalLabel
    ) {
        label.textContent = originalLabel;
    }
    }


    /*
    * Wishlistの商品販売期間を判定
    */
    function updateWishlistCard(card) {
    const button = card.querySelector(
        WISHLIST_BUTTON_SELECTOR
    );

    if (!button) return;

    /*
    * 商品情報取得済み
    */
    if (card.dataset.eleSaleLoaded === 'true') {
        const startValue =
        card.dataset.eleSaleStart || '';

        const endValue =
        card.dataset.eleSaleEnd || '';

        const startTime = parseJstDate(startValue);
        const endTime = parseJstDate(endValue);

        const now = Date.now();

        /*
        * START前
        */
        if (startTime && now < startTime) {
        const startLabel =
            formatWishlistStartDate(startValue);

        disableWishlistButton(
            button,
            `${startLabel} 販売開始`
        );

        return;
        }

        /*
        * END後
        */
        if (endTime && now >= endTime) {
        disableWishlistButton(
            button,
            '販売終了'
        );

        return;
        }

        /*
        * 販売期間中または期間指定なし
        */
        restoreWishlistButton(button);

        return;
    }


    /*
    * タグ確認が終わるまでは購入を一時停止
    */
    disableWishlistButton(
        button,
        button.querySelector('.MuiButton-label')?.textContent.trim() ||
        'ADD TO CART'
    );


    const handle = getWishlistProductHandle(card);

    if (!handle) {
        restoreWishlistButton(button);
        return;
    }


    fetchWishlistProduct(handle)
        .then((product) => {
        const period =
            getWishlistSalePeriod(product.tags);

        card.dataset.eleSaleLoaded = 'true';

        if (period.start) {
            card.dataset.eleSaleStart =
            period.start;
        }

        if (period.end) {
            card.dataset.eleSaleEnd =
            period.end;
        }

        updateWishlistCard(card);
        })
        .catch(() => {
        restoreWishlistButton(button);
        });
    }


    /*
    * Wishlist全体を確認
    */
    function applyWishlistSalePeriod() {
    document
        .querySelectorAll(WISHLIST_BUTTON_SELECTOR)
        .forEach((button) => {
        const card =
            button.closest('.MuiCard-root');

        if (!card) return;

        updateWishlistCard(card);
        });
    }


  function applySalePeriod() {
    document.querySelectorAll(SELECTOR).forEach((element) => {
        if (!isSaleEnded(element)) return;

        const scope = element.getAttribute('data-ele-sale-scope');

        if (scope === 'card') {
        disableProductCard(element);
        } else {
        disableBuyButtons(element);
        }
    });

    /*
    * Wishlist Plus / Wishlist Hero
    */
    applyWishlistSalePeriod();
  }


  /*
   * Ajax / Quick Buy / 商品再描画に対応
   */
  const observer = new MutationObserver(() => {
    applySalePeriod();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });


  /*
   * 初回実行
   */
  applySalePeriod();


  /*
   * END時刻を監視
   * 最大約1秒の差で販売停止
   */
  setInterval(() => {
    applySalePeriod();
  }, 1000);


  /*
   * 万が一テーマ側でボタンが再有効化された場合も
   * END後ならクリックを止める
   */
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target.closest(
        'button[type="submit"], .product-card__quick-add-button, .shopify-payment-button'
      );

      if (!target) return;

      const scope = target.closest(SELECTOR);

      if (!scope || !isSaleEnded(scope)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const scopeType = scope.getAttribute('data-ele-sale-scope');

      if (scopeType === 'card') {
        disableProductCard(scope);
      } else {
        disableBuyButtons(scope);
      }
    },
    true
  );


  /*
   * フォーム送信も最終的にブロック
   */
  document.addEventListener(
    'submit',
    (event) => {
      const scope = event.target.closest(SELECTOR);

      if (!scope || !isSaleEnded(scope)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      disableBuyButtons(scope);
    },
    true
  );

  /*
    * Wishlist側の購入処理を最終ブロック
    */
    document.addEventListener(
    'click',
    (event) => {
        const button = event.target.closest(
        WISHLIST_BUTTON_SELECTOR
        );

        if (!button) return;

        /*
        * タグ確認中または販売期間外の場合は
        * Wishlistアプリ側のAdd to Cart処理を止める
        */
        if (
        button.disabled ||
        button.dataset.eleWishlistBlocked === 'true'
        ) {
        event.preventDefault();
        event.stopImmediatePropagation();
        }
    },
    true
  );
})();